// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var Logger = (function () {
    function Logger(enableClientSideLogging) {
        this.enableClientSideLogging = enableClientSideLogging;
    }
    Logger.prototype.log = function (message) {
        if (this.enableClientSideLogging) {
            console.log(["TRACE", "Coveo for Sitecore"].concat(message));
        }
    };
    return Logger;
}());
exports.__esModule = true;
exports["default"] = Logger;



//////////////////
// WEBPACK FOOTER
// ./Base/Logger.ts
// module id = 6
// module chunks = 0